/**
 * AccountSignOut.jsx
 * Created by Michael Bray on 2/14/18.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import * as Icons from '../../sharedComponents/icons/Icons';
import CartTimer from '../../sharedComponents/CartTimer';
import AccountProfileDropdown from './AccountProfileDropdown';
import { pluralize } from '../../../helpers/stringHelper';

import { ACCOUNT_PROPS } from '../constants';

export default class AccountSignOut extends React.PureComponent {
    static propTypes = {
        cart: PropTypes.shape({
            expiration: PropTypes.string,
            showTimer: PropTypes.bool,
            reservations: PropTypes.array
        }),
        account: ACCOUNT_PROPS,
        logout: PropTypes.func,
        isGuest: PropTypes.bool,
        openLoginModal: PropTypes.func
    };

    static defaultProps = {
        cart: {
            showTimer: false,
            reservations: []
        }
    };

    render() {
        let cartTimer = null;
        const numCartItems = get(this.props, 'cart.reservations', []).length;

        const cartAriaLabel = numCartItems > 0
            ? `Cart - ${numCartItems} ${pluralize(numCartItems, 'item', 'items')} in cart.`
            : 'Cart';

        if (this.props.cart.showTimer) {
            cartTimer = (
                <div className="rec-small-timer">
                    <CartTimer date={new Date(this.props.cart.expiration)} />
                </div>
            );
        }

        return (
            <div className="nav-user-actions">
                <a
                    aria-label={cartAriaLabel}
                    href="/cart"
                    className="nav-interactions-link nav-interactions-link-cart">
                    <Icons.IconCart />
                    {numCartItems > 0 && (
                        <span className="cart-quantity">
                            {numCartItems}
                        </span>
                    )}
                </a>
                {cartTimer}
                <AccountProfileDropdown
                    account={this.props.account}
                    isGuest={this.props.isGuest}
                    openLoginModal={this.props.openLoginModal}
                    signOut={this.props.logout} />
            </div>
        );
    }
}